<app-list-view-toolbar [columns]="columns" [preferencesKey]="preferencesKey"></app-list-view-toolbar>
<div class="d-none d-md-block table-container">
  <table class="table table-hover">
    <thead>
      <tr>
        @if (hasInlineContextMenu) {
          <th class="menu-edit"></th>
        }
        @for (column of selectedColumns; track column) {
          @if (column.helpText) {
            <th
              class="column-header"
              appTooltip="{{ column.helpText | translate }}"
              tooltipPosition="below"
              [dh-list-view-header]="column.id"
              [canSort]="column.canSort"
              (stateChange)="onStateChange($event)"
              >
              {{ column.caption | translate }}
            </th>
          }
          @if (!column.helpText) {
            <th
              class="column-header"
              [dh-list-view-header]="column.id"
              [canSort]="column.canSort"
              (stateChange)="onStateChange($event)"
              >
              {{ column.caption | translate }}
            </th>
          }
        }
        @if (hasContextMenu) {
          <th></th>
        }
        @if (hasInlineContextMenu) {
          <th></th>
        }
      </tr>
    </thead>
    <tbody class="table-striped">
      @for (row of rows | slice: from : to; track row; let i = $index) {
        <tr appListViewItem [class.highlight]="row.highlight">
          @if (hasInlineContextMenu) {
            <td class="menu-edit">
              <app-context-menu-inline
                [context]="row.dataSource"
                [menuDefinition]="contextMenuDefinition"
                [isEdit]="true"
              ></app-context-menu-inline>
            </td>
          }
          @for (column of selectedColumns; track column) {
            <td (click)="onRowClicked(row, $event)">
              <dh-custom-toogle-view
                [viewType]="column.dataType"
                [value]="row.getValue(column)"
                [helpText]="row.getHelpText(column)"
                (toggleChanged)="onToggleChanged($event, row.dataSource)"
              ></dh-custom-toogle-view>
            </td>
          }
          @if (hasContextMenu) {
            <td>
              <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" class="float-right"></app-context-menu>
            </td>
          }
          @if (hasInlineContextMenu) {
            <td>
              <app-context-menu-inline [context]="row.dataSource" [menuDefinition]="contextMenuDefinition"></app-context-menu-inline>
            </td>
          }
        </tr>
      }
      <tr class="list-summary">
        @if (hasInlineContextMenu) {
          <td class="menu-edit"></td>
        }
        @for (column of selectedColumns; track column) {
          <td>
            @if (column.sum) {
              @for (summary of sumValues(column); track $index) {
                <div>{{ summary.displayValue }}</div>
              }
            }
          </td>
        }
        @if (hasContextMenu) {
          <td></td>
        }
        @if (hasInlineContextMenu) {
          <td></td>
        }
      </tr>
    </tbody>
  </table>
  <app-paging [totalCount]="totalCount" (onPageChange)="pagingChanged($event)"></app-paging>
</div>
<div class="d-block d-md-none">
  @for (row of rows; track row) {
    <div class="entry-m" [class.highlight]="row.highlight">
      @if (hasContextMenu) {
        <div class="float-right">
          <app-context-menu [context]="row.dataSource" [menuDefinition]="contextMenuDefinition" [alwaysVisible]="true"></app-context-menu>
        </div>
      }
      <ul (click)="onRowClicked(row, $event)">
        @for (column of selectedColumns; track column) {
          <li>
            <div class="property-name-m">{{ column.caption | translate }}</div>
            <dh-custom-view [viewType]="column.viewType" [value]="row.getValue(column)" [helpText]="row.getHelpText(column)"></dh-custom-view>
          </li>
        }
      </ul>
    </div>
  }
</div>
